<template>
  <div class="testMain performance-table" style="background: #2d3136;color: #fff">
    <div v-loading="all_skin_loading" element-loading-background="rgba(0, 0, 0, 0.2)">
      <div
        class="hok_is_pass"
        style="text-align: right; margin-bottom: 10px">
        <el-checkbox @change="all_skin_data_api(true)" v-model="is_pass"
          >仅显示不达标</el-checkbox
        >
        <el-button
          style="margin-left: 20px"
          size="mini"
          type="primary"
          @click="exportSkin"
          >导出表格</el-button
        >
      </div>
      <div class="all_table_hok">
        <div class="all_table_hok_box">
          <div class="all_table_hok_left radios-top">版本</div>
          <div class="radil_list">
            <el-radio-group
              @change="onVersionChange"
              size="small"
              v-model="radio_versions"
            >
              <el-radio :label="'全版本'">全版本 </el-radio>
              <el-radio
                v-for="item in skin_versions"
                :label="item"
                :key="item"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <div class="all_table_hok_box">
          <div class="all_table_hok_left">测试用例</div>
          <div class="radil_list">
            <div class="radil_list">
              <el-radio-group
                @change="test_change"
                size="small"
                v-model="radio_test"
              >
                <el-radio
                  v-for="item in test_type"
                  :label="item.value"
                  :key="item"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
              
              <el-select
                @change="onOutTestChange"
                v-if="radio_test == 3"
                size="mini"
                v-model="hero_skin"
              >
                <el-option
                  v-for="item in test_type_chek"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="all_table_hok_box">
          <div class="all_table_hok_left">英雄皮肤</div>
          <div class="radil_list">
            <el-form style="margin: 0px" :inline="true" size="mini">
              <el-form-item label="">
                <el-radio-group
                  @change="all_skin_data_api(true)"
                  size="small"
                  v-model="hero_check"
                >
                  <el-radio
                    v-for="item in hero_list"
                    :label="item"
                    :key="item"
                    >{{ item }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="hero_check == '英雄和皮肤'"
                label="选择英雄"
                class=""
              >
                <el-select
                  @change="all_skin_data_api(true)"
                  filterable
                  v-model="hero_check_id"
                >
                  <el-option
                    v-for="item in hokIcon?.hero_list"
                    :key="item.hero_id"
                    :label="item.hero_name"
                    :value="item.hero_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="hero_check == '英雄和皮肤'"
                label="选择皮肤"
              >
                <el-select
                  @change="all_skin_data_api(true)"
                  v-model="skin_check_id"
                >
                  <el-option
                    v-for="item in hokIcon?.skin_list?.[hero_check_id]"
                    :key="item.skin_id"
                    :label="item.skin_name"
                    :value="item.skin_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="all_table_hok_box">
          <div class="all_table_hok_left">皮肤等级</div>
          <div class="radil_list">
            <el-select
              filterable
              size="mini"
              v-model="skinLevel"
              @change="onLevelChange"
            >
              <el-option
                v-for="item in level_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="all_table_hok_box">
          <div class="all_table_hok_left">上线时间</div>
          <div class="radil_list">
            <el-radio-group size="small" v-model="radio_time" @change="onTimeChange">
              <el-radio
                v-for="item in time_list"
                :label="item.value"
                :key="item"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
            <el-date-picker
              size="mini"
              v-model="year"
              type="daterange"
              class="dist-picker"
              @change="timeChange"
              range-separator="To"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </div>
        </div>
        <div class="all_table_hok_box">
          <div class="all_table_hok_left radios-bottom">设备</div>
          <div
            style="height: 45px;line-height: 45px; border-bottom: 0px solid #606469"
            class="radil_list_device"
          >
            <el-radio-group
              @change="all_skin_data_api(true)"
              size="small"
              v-model="radio_device"
            >
              <el-radio
                v-for="item in devices_versions"
                :label="item.id"
                :key="item"
              >
                <el-tooltip :content="item.model" placement="top">
                  <span class="ellipsis-text">{{ item.model }}</span>
                </el-tooltip></el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>  

    <div class="spacName">
      <el-table v-loading="staticsLoading" element-loading-background="rgba(0, 0, 0, 0.2)" :data="staticsTableData" class="w-50 my-5 my-table-hok table-statics" 
        :header-cell-style="{
          background: '#42484E',
          color: '#fff',
        }">
        <el-table-column width="100" prop="model" label="机型">
        </el-table-column>
        <el-table-column width="100" prop="inside_skin_num" label="局内测试皮肤数">
        </el-table-column>
        <el-table-column width="100" prop="inside_skin_pass_num" label="局内通过皮肤数">
        </el-table-column>
        <el-table-column width="100" prop="skin_num" label="局外测试皮肤数">
        </el-table-column>
        <el-table-column width="100" prop="skin_pass_num" label="局外通过皮肤数">
        </el-table-column>
      </el-table>

      <el-table
        class="my-table-hok"
        size="mini"
        :header-cell-style="{
          background: '#42484E',
          color: '#fff',
        }"
        v-if="radio_test == 4"
        :span-method="mergeCells2"
        v-loading="all_skin_loading"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :data="all_skin_data"
        @sort-change="sort_change">
        <el-table-column width="100" label="ID">
          <template #default="scope">
            <span>{{ scope.row.model }}</span>
          </template>
        </el-table-column>

        <el-table-column width="100" label="英雄">
          <template #default="scope">
            <span>{{ scope.row.data.skin_info.hero_name }}</span>
          </template>
        </el-table-column>

        <el-table-column width="100" label="皮肤">
          <template #default="scope">
            <span>{{ scope.row.data.skin_info.skin_name }}</span>
          </template>
        </el-table-column>

        <el-table-column width="100" label="等级">
          <template #default="scope">
            <span>{{ scope.row.data.skin_level }}</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable="custom"
          prop="date"
          width="270"
          label="测试日期"
        >
          <template #default="scope">
            <span
              :style="
                'margin-left:' +
                (scope.row.data.level == 0 ? '0px' : '10px')
              "
            >
              {{ scope.row.data.date
              }}<i
                style="cursor: pointer"
                v-if="scope.row.data.level == 0 && scope.row.show"
                @click="expandCheck_all(scope.row)"
                :class="
                  scope.row.check
                    ? 'el-icon-arrow-down'
                    : 'el-icon-arrow-up'
                "
              ></i>
            </span>
            <span
              v-if="scope.row.many"
              @click="expandCheck_all_add(scope.row)"
              style="color: #70c1f1; cursor: pointer"
              >(查看更多)</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="date" width="100" label="结论">
          <template #default="scope">
            <span
              :class="
                scope.row.data.risk == '达标'
                  ? 'com_risk_green'
                  : 'com_risk_red'
              "
              >{{ scope.row.data.risk }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="avg_fps"
          sortable="custom"
          label="平均帧率(高于)"
        >
          <template #default="scope">
            <span :style="{color: scope.row.data.colors.avg_fps}">{{ scope.row.data.avg_fps }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="fps_lt_40_pcnt"
          label="低帧率占比(低于)"
        >
          <template #default="scope">
            <span :style="{color: scope.row.data.colors.fps_lt_40_pcnt}">
              {{ scope.row.data.fps_lt_40_pcnt }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="min_fps"
          label="最低帧率(高于)"
        >
          <template #default="scope">
            <span :style="{color: scope.row.data.colors.min_fps}">
              {{ scope.row.data.min_fps }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="avg_cpu"
          label="CPU占用率均值(低于)"
        >
          <template #default="scope">
            <span :style="{color: scope.row.data.colors.avg_cpu}">
              {{ scope.row.data.avg_cpu }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="max_pss"
          label="内存峰值(低于)"
        >
          <template #default="scope">
            <span :style="{color: scope.row.data.colors.max_pss}">
              {{ scope.row.data.max_pss }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="caton"
          label="卡顿率(低于)"
        >
          <template #default="scope">
            <span :style="{color: scope.row.data.colors.caton}">
              {{ scope.row.data.caton }}
            </span>
          </template>
        </el-table-column>
        
        <el-table-column label="链接">
          <template #default="scope">
            <span>
              <a
                target="_blank"
                style="cursor: pointer; color: #70c1f1"
                :href="scope.row.data.url"
                >查看</a
              >
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div v-else class="my-table-hok-out">
        <el-table
          class="my-table-hok"
          size="mini"
          v-loading="all_skin_loading"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :header-cell-style="{
            background: '#42484E',
            color: '#fff',
          }"
          :span-method="mergeCells3"
          :data="outSkinDataTrue"
          @sort-change="sort_change"
        >
          <el-table-column width="100" label="ID">
            <template #default="scope">
              <span>{{ scope.row.model }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100" label="英雄">
            <template #default="scope">
              <span>{{ scope.row.data.skin_info.hero_name }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100" label="皮肤">
            <template #default="scope">
              <span>{{ scope.row.data.skin_info.skin_name }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100" label="等级">
            <template #default="scope">
              <span>{{ scope.row.data.skin_level }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100" label="动作">
            <template #default="scope">
              <span style="color: rgb(112, 193, 241)">
                {{ getActionText(scope.row.data.action) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            sortable="custom"
            prop="date"
            width="270"
            label="测试日期"
          >
            <template #default="scope">
              <span
                :style="
                  'margin-left:' +
                  (scope.row.data.level == 0 ? '0px' : '10px')
                "
              >
                {{ scope.row.data.date
                }}<i
                  style="cursor: pointer"
                  v-if="!scope.row.isChild"
                  @click="expandCheck_all_out(scope.row)"
                  :class="
                    scope.row.check
                      ? 'el-icon-arrow-down'
                      : 'el-icon-arrow-up'
                  "
                ></i>
              </span>
              <span
                v-if="scope.row.many"
                @click="expandCheck_all_add_outer(scope.row)"
                style="color: #70c1f1; cursor: pointer"
                >(查看更多)</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="date" width="100" label="结论">
            <template #default="scope">
              <span
                :class="
                  scope.row.data.risk == '达标'
                    ? 'com_risk_green'
                    : 'com_risk_red'
                "
                >{{ scope.row.data.risk }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="hero_skin ? (hero_skin == 'come' ? '入场' : '待机') : '全部'"
          >
            <el-table-column
              prop="avg_fps"
              sortable="custom"
              label="平均帧率(高于)"
            >
              <template #default="scope">
                <span :style="{color: scope.row.data.colors.avg_fps}">{{ scope.row.data.avg_fps }}</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="fps_lt_40_pcnt"
              label="低帧率占比(低于)"
            >
              <template #default="scope">
                <span :style="{color: scope.row.data.colors.fps_lt_40_pcnt}">
                  {{ scope.row.data.fps_lt_40_pcnt }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="min_fps"
              label="最低帧率(高于)"
            >
              <template #default="scope">
                <span :style="{color: scope.row.data.colors.min_fps}">
                  {{ scope.row.data.min_fps }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="avg_cpu"
              label="CPU占用率均值(低于)"
            >
              <template #default="scope">
                <span :style="{color: scope.row.data.colors.avg_cpu}">
                  {{ scope.row.data.avg_cpu }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="max_pss"
              label="内存峰值(低于)"
            >
              <template #default="scope">
                <span :style="{color: scope.row.data.colors.max_pss}">
                  {{ scope.row.data.max_pss }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="caton"
              label="卡顿率(低于)"
            >
              <template #default="scope">
                <span :style="{color: scope.row.data.colors.caton}">
                  {{ scope.row.data.caton }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="链接">
              <template #default="scope">
                <span>
                  <a
                    target="_blank"
                    style="cursor: pointer; color: #70c1f1"
                    :href="scope.row.data.url"
                    >查看</a
                  >
                </span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <el-form
        :inline="true"
        size="mini"
        class="spacName foot_hok"
        style="
          display: flex;
          align-items: center;
          justify-content: end;
        ">
        <el-form-item label="每页">
          <el-input
            @change="all_skin_data_api(true)"
            v-model="skin_size"
            style="width: 55px; height: 28px"
          ></el-input>
        </el-form-item>

        <el-form-item label="条记录"></el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-pagination
            v-model:currentPage="skin_page"
            :page-size="skin_size"
            layout="total, prev, pager, next, jumper"
            :total="all_skin_data_page"
            @current-change="all_skin_data_api(false)"
          ></el-pagination>
        </el-form-item>
      </el-form>
    </div>

    <standard-table
      ref="standardTable"
      :project="localProject" 
      :radio_versions="radio_versions" 
      :skinLevel="skinLevel" 
      :start_date="start_date" 
      :end_date="end_date"
      :radio_test="radio_test"
      :hero_skin="hero_skin" />
  </div>
</template>

<script>
import {
  readtesthokIcon,
} from "@/store/project/getters";
import { dateConversion } from "@/utils"; //类型
import { store } from "@/store";
import { getLocalProject } from "@/utils";
import { ElMessage } from "element-plus";
import "@/assets/iconfont/font_3410179_5uqi6h3hn2r/iconfont.css"; //引入仓库
import axios from 'axios'
import StandardTable from './standard-table.vue'
import { sub } from "date-fns";

const useTabToggle = {
  props: {
  },

  data() {
    return {
      num: 0
    }
  },

  methods: {
    async handleClickTab() {
      this.num++;
      if (this.num == 1) {
        await this.skin_version_api();
        await this.skin_device_api();
        this.all_skin_data_api(true);
        this.getStaticsData()
        this.getStandartData()
      }
    },

    async skin_version_api() {
      const {data} = await axios('report/skin_versions/', {
        params: {
          project: this.localProject,
          page_type: this.$route.query.type,
        }
      })
      this.testhokSkinVersions = data
    },
  }
}

const useMain = {
  data() {
    return {
      is_pass: false,
      radio_versions: "全版本",
      radio_test: 4,
      test_type: [
        { name: "局内", value: 4 },
        { name: "局外", value: 3 },
      ],
      test_type_chek: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "入场",
          value: "come",
        },
        {
          name: "待机",
          value: "idle",
        },
      ],
      skin_check_id: "",
      hero_check_id: "",
      hero_skin: "",
      hero_list: ["全部", "英雄", "英雄和皮肤"],
      hero_check: "全部",
      radio_time: 4,
      time_list: [
        { name: "全部", value: 4 },
        { name: "近半年", value: 5 },
        { name: "近一年", value: 6 },
      ],
      year: [],
      radio_device: 0,
      all_skin_loading: false,
      all_skin_data: [],
      
      skin_page: 1,
      skin_size: 10,
      start_date: "",
      end_date:  "",
      order_by:  "",
      reverse: "-",
      filter_page_data:  {},
      all_skin_data_page: 0,
      testhokSkinData: {},
      testhokSkinDataPage: {},
      testhokSkinDevices: [],
      testhokSkinVersions: {},
    }
  },

  computed: {
    hokIcon() {
      return readtesthokIcon(store);
    },

    skin_versions() {
      return this.testhokSkinVersions?.version_list;
    },

    devices_versions() {
      const devices = this.testhokSkinDevices

      // 找到 SM-J200 的设备对象
      const targetDeviceIndex = devices.findIndex(
        (device) => device.model === "SM-J200"
      );
      if (targetDeviceIndex !== -1) {
        // 将该设备移到数组第一位
        const [targetDevice] = devices.splice(targetDeviceIndex, 1);
        devices.unshift(targetDevice);
      }

      return devices;
    },

    addHokAll() {
      return this.testhokSkinDataPage
    }
  },

  methods: {
    onTimeChange() {
      if (this.radio_time == 4) {
        this.start_date = ''
        this.end_date = ''
      } else if (this.radio_time == 5) {
        const startDate = sub(new Date, {months: 6})

        this.start_date = this.formatDate(startDate)
        this.end_date = this.formatDate(new Date)
      } else if (this.radio_time == 6) {
        const startDate = sub(new Date, {months: 12})

        this.start_date = this.formatDate(startDate)
        this.end_date = this.formatDate(new Date)
      }

      this.all_skin_data_api(true)
      this.getStandartData()
    },

    getStandartData() {
      this.$refs.standardTable.getData()
    },

    getActionText(action) {
      if (action === "进场") {
        return "入场";
      } else if (action === "站定") {
        return "待机";
      }
      return action;
    },

    onOutTestChange() {
      this.all_skin_data_api(true)
      this.getStandartData()
    },

    onVersionChange() {
      this.all_skin_data_api(true)
      this.getStaticsData()
      this.getStandartData()
    },

    onLevelChange() {
      this.all_skin_data_api(true)
      this.getStaticsData()
      this.getStandartData()
    },

    async all_skin_data_api(type) {
      this.skin_page = type ? 1 : this.skin_page;
      this.all_skin_loading = true;
      const {data} = await axios('report/all_skin_data/', {
        params: {
          project: this.localProject,
          version: this.radio_versions === "全版本" ? "" : this.radio_versions,
          type: this.radio_test,
          action: this.radio_test == 4 ? "" : this.hero_skin,
          hero_skin:
            this.hero_check == "英雄"
              ? "hero"
              : this.hero_check == "全部"
              ? ""
              : this.skin_check_id,
          device: this.radio_device,
          start_date: this.start_date,
          end_date: this.end_date,
          order_by: this.order_by,
          reverse: this.reverse,
          page: this.skin_page,
          page_size: this.skin_size,
          is_pass: this.is_pass ? "no_pass" : "",
          level: this.skinLevel,
          page_type: this.$route.query.type,
        }
      })
      this.testhokSkinData = data

      this.allSkinData()
      this.all_skin_loading = false
    },

    exportSkin() {
      let b = this.$message({
        //Message 消息提示
        message: "导出中,请耐心等待....",
        showClose: true,
        duration: 0,
      });
      const response_data = axios('report/all_skin_export/', {
        params: {
          project: this.localProject,
          version: this.radio_versions === "全版本" ? "" : this.radio_versions,
          type: this.radio_test,
          action: this.radio_test == 4 ? "" : this.hero_skin,
          hero_skin:
            this.hero_check == "英雄"
              ? this.hokIcon.hero_list.filter(
                  (v) => v.hero_id == this.hero_check_id
                )[0].hero_name
              : this.skin_check_id,
          device: this.radio_device,
          start_date: this.start_date,
          end_date: this.end_date,
          order_by: this.order_by,
          reverse: this.reverse,
          page: this.skin_page,
          page_size: this.skin_size,
          is_pass: this.is_pass ? "pass" : "no_pass",
          page_type: this.$route.query.type,
        },
        responseType: 'blob',
      });
      response_data.then((value) => {
        var elink = document.createElement("a");
        elink.download = "性能总表" + ".xlsx";
        elink.style.display = "none";
        var blob = new Blob([value], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        });

        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        b.close();
      });
    },

    test_change() {
      this.skin_device_api();
      if (this.radio_test == 3) {
        this.hero_skin = "";
      }
      this.all_skin_data_api(true);
      this.getStandartData()
    },

    heroSkinChange() {
      this.skin_check_id = this.hokIcon.skin_list[this.hero_check_id][0].skin_id;
      this.all_skin_data_api(true);
    },

    timeChange(dates) {
      this.radio_time = 0;
      if (dates && dates.length === 2) {
        this.start_date = this.formatDate(dates[0]);
        this.end_date = this.formatDate(dates[1]);
      } else {
        this.start_date = "";
        this.end_date = "";
      }
      this.all_skin_data_api(true);
      this.getStandartData()
    },

    mergeCells2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.all_skin_data.filter(
          (item) => item.model === row.model
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.all_skin_data.findIndex((item) => item.model === row.model) ===
            rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },

    sort_change(column) {
      this.order_by = column.prop ? column.prop : "";
      this.reverse = column.order
        ? column?.order == "ascending"
          ? ""
          : "-"
        : "";
      this.all_skin_data_api(true);
    },

    getExcludeKeys(data_all) {
      return Object.keys(data_all).filter(key => key != '发布标准' && key != '达标率')
    },

    allSkinData() {
      let data_all = this.testhokSkinData
      this.all_skin_data = [];
      this.all_skin_data_page = this.getExcludeKeys(data_all).length;
      let obj = Object.keys(data_all).slice(
        (this.skin_page - 1) * this.skin_size,
        this.skin_page * this.skin_size
      ); //获取key
      // this.filter_page_data=obj
      let data = this.extractSubsetFromObject(data_all, obj);
      this.filter_page_data = data;

      for (let i in data) {
        let show = data[i].length > 1 ? true : false;
        data[i].forEach((v) => {
          if (v.level == 0) {
            this.all_skin_data.push({
              id: Math.random(),
              model: i,
              action: v.action,
              data: v,
              check: true,
              show: show,
              many: true,
            });
          }
        });
      }

      if (this.radio_test == 3) { //局外表格数据
        this.out_skin_data = JSON.parse(JSON.stringify(this.all_skin_data))
      }
    },

    async skin_device_api() {
      const {data} = await axios('report/skin_device_list_v1/', {
        params: {
          project: this.localProject,
          type: this.radio_test,
          page_type: this.$route.query.type,
        }
      })
      this.testhokSkinDevices = data
      this.radio_device = this.devices_versions[0].id;
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 补零
      const day = String(date.getDate()).padStart(2, "0"); // 补零
      return `${year}-${month}-${day}`;
    },

    extractSubsetFromObject(originalObject, keysArray) {
      return Object.keys(originalObject) // 获取所有键
        .filter((key) => keysArray.includes(key)) // 筛选出需要的键
        .reduce((newObj, key) => {
          // 构建新对象
          newObj[key] = originalObject[key];
          return newObj;
        }, {});
    }
  }
}

const useStatics = { //统计表格相关功能
  data() {
    return {
      staticsLoading: false,
      staticsTableData: []
    }
  },

  methods: {
    async getStaticsData() {
      this.staticsLoading = true
      const version = this.radio_versions === '全版本' ? '' : this.radio_versions
      const url = `report/all_skin_num/?project=${this.localProject}&skin_id=${this.skin_id}&level=${this.skinLevel}&version=${version}&page_type=${this.$route.query.type}`
      //const url = 'report/all_skin_num/?project=34&skin_id=10502&level=S+&version=1.0'
      const {data} = await axios(url)
      this.staticsLoading = false

      this.staticsTableData = Object.keys(data).map(model => {
        const value = data[model]

        return {
          model,
          ...value,
        }
      })
    }
  }
}

const useInViewMore = { //局内表格的查看更多功能
  methods: {
    expandCheck_all(data) {
      data.check = !data.check;

      if (!data.check) {
        let list = [];
        let addData = this.filter_page_data[data.model].filter(
          (v) => v.level != 0
        );

        addData.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
          });
        });
        let index = this.all_skin_data.findIndex(
          (v) => v.model == data.model && v.data.time == data.time
        );
        if (index !== -1) {
          // 确保找到了索引
          this.all_skin_data.splice(index + 1, 0, ...list);
        }
      } else {
        this.all_skin_data = this.all_skin_data.filter(
          (item) => !(item.model === data.model && item.data.level === 1)
        );
      }
      const modelMap = new Map();

      // 标记最后一个相同model为true，其他为false
      for (let i = this.all_skin_data.length - 1; i >= 0; i--) {
        const model = this.all_skin_data[i].model;

        if (!modelMap.has(model)) {
          this.all_skin_data[i].many = true; // 最后一个相同model的many设为true
          modelMap.set(model, true);
        } else {
          this.all_skin_data[i].many = false; // 之前出现过的设为false
        }
      }
      data.many = false;
    },

    async expandCheck_all_add(data) {
      const res = await axios('report/all_skin_data_more/', {
        params: {
          project: this.localProject,
          version: this.radio_versions === "全版本" ? "" : this.radio_versions,
          type: this.radio_test,
          action: this.radio_test == 4 ? "" : (data.data.action == '进场' ? 'come' : 'idle'),
          hero_skin: data.model,
          device: this.radio_device,
          start_date: this.start_date,
          end_date: this.end_date,
          order_by: this.order_by,
          reverse: this.reverse,
          page: this.all_skin_data.filter((v) => v.model == data.model).length,
          is_pass: this.is_pass ? "no_pass" : "pass",
          page_type: this.$route.query.type,
        }
      })
      this.testhokSkinDataPage = res.data

      if (this.addHokAll.length > 0) {
        let list = [];
        this.addHokAll.forEach((v) => {
          list.push({
            model: data.model,
            data: v,
          });
        });
        this.all_skin_data.forEach((v) => {
          if (v.model == data.model) {
            v.check = false;
          }
        });
        this.insertAfterLastOccurrenceAll(data.model, this.addHokAll);
        this.insertAfterLastOccurrenceAddAll(data.model, list);
        const modelMap = new Map();

        // 标记最后一个相同model为true，其他为false
        for (let i = this.all_skin_data.length - 1; i >= 0; i--) {
          const model = this.all_skin_data[i].model;

          if (!modelMap.has(model)) {
            this.all_skin_data[i].many = true; // 最后一个相同model的many设为true
            modelMap.set(model, true);
          } else {
            this.all_skin_data[i].many = false; // 之前出现过的设为false
          }
        }
        const modelMap1 = new Map();

        // 首先遍历所有的数据，将每个 model 出现的索引记录下来
        for (let i = 0; i < this.all_skin_data.length; i++) {
          const model = this.all_skin_data[i].model;

          // 如果 map 中没有这个 model，初始化为一个空数组
          if (!modelMap1.has(model)) {
            modelMap1.set(model, []);
          }

          // 将当前索引添加到对应的 model 的数组中
          modelMap1.get(model).push(i);
        }

        // 遍历 modelMap，并设置第一个出现的该 model 的 show 为 true，其余为 false
        modelMap1.forEach((indices) => {
          // 如果同一个 model 只出现一次，设置 show 为 false
          if (indices.length === 1) {
            this.all_skin_data[indices[0]].show = false;
          } else {
            // 如果同一个 model 出现多次，第一个设置为 true，其他设置为 false
            this.all_skin_data[indices[0]].show = true;
            for (let i = 1; i < indices.length; i++) {
              this.all_skin_data[indices[i]].show = false;
            }
          }
        });
      } else {
        ElMessage.error("暂无更多数据");
      }
    },

    insertAfterLastOccurrenceAll(model, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.filter_page_data[model].forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.filter_page_data[model].splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.filter_page_data[model].push(...newDevice);
      }
    },

    insertAfterLastOccurrenceAddAll(model, newDevice) {
      // Find the last occurrence of the given model
      let lastIndex = -1;
      this.all_skin_data.forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index;
        }
      });

      // Insert the new device after the last occurrence
      if (lastIndex !== -1) {
        this.all_skin_data.splice(lastIndex + 1, 0, ...newDevice);
      } else {
        // If the model is not found, append the new device at the end
        this.all_skin_data.push(...newDevice);
      }
    },
  }
}

const useOutTable = {
  data() {
    return {
      out_skin_data: [], //局外表格数据
    }
  },

  computed: {
    outSkinDataTrue() {
      return this.out_skin_data.filter(v => !v.isHide)
    }
  },

  methods: {
    mergeCells3({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.outSkinDataTrue.filter(
          (item) => item.model === row.model
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.outSkinDataTrue.findIndex((item) => item.model === row.model) ===
            rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },
  }
}

const useOutViewMore = { //局外表格的查看更多功能
  data() {
    return {

    }
  },

  methods: {
    async expandCheck_all_add_outer(data) {
      const action = data.action
      const res = await axios('report/all_skin_data_more/', {
        params: {
          project: this.localProject,
          version: this.radio_versions === "全版本" ? "" : this.radio_versions,
          type: this.radio_test,
          action: this.radio_test == 4 ? "" : (action == '进场' ? 'come' : 'idle'),
          hero_skin: data.model,
          device: this.radio_device,
          start_date: this.start_date,
          end_date: this.end_date,
          order_by: this.order_by,
          reverse: this.reverse,
          page: this.out_skin_data.filter((v) => v.model == data.model && v.action == data.action).length,
          is_pass: this.is_pass ? "no_pass" : "pass",
        }
      })

      if (res.data.length > 0) {
        data.check = false
        data.many = false
        const index = this.out_skin_data.findIndex(item => item.id == data.id)

        const moreRow = res.data.map((row, index) => {
          return {
            id: Math.random(),
            action: row.action,
            many: index == (res.data.length - 1) ? true : false,
            model: row.skin_info.id,
            isChild: true, //是更多项
            data: row
          }
        })
        
        this.out_skin_data.splice(index + 1, 0, ...moreRow)
      } else {
        ElMessage.error("暂无更多数据");
      }
    },

    expandCheck_all_out(row) {
      const rowIndex = this.out_skin_data.findIndex(item => item.id == row.id)
     
      for(let i=rowIndex+1; i < this.out_skin_data.length; i++) {
        if (this.out_skin_data[i].isChild) {
          this.out_skin_data[i].isHide = !row.check
        } else {
          break
        }
      }

      row.check = !row.check
    }
  }
}

export default {
  mixins: [useTabToggle, useMain, useStatics, useInViewMore, useOutViewMore, useOutTable],

  components: {StandardTable},

  data() {
    return {
      localProject: 57,
      skinLevel: '',
      level_list: [
        {label: '全部', value: ''},
        {label: 'B', value: 'B'},
        {label: 'A', value: 'A'},
        {label: 'S', value: 'S'},
        {label: 'S+', value: 'S+'},
        {label: 'S++', value: 'S++'},
      ],
    }
  },
}
</script>

<style scoped>
.current_img {
  width: 46px;
  display: inline-block;
  height: 46px;
  margin-right: 5px;
}
.current_img img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.com_risk_red {
  color: #dc143c;
}
.com_risk_green {
  color: #00b050;
}
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(1px); /* 虚化效果 */
  z-index: 100; /* 将遮罩层置于页面内容之上 */
}
.Ecard {
  width: 1260px;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 2px 10px rgb(179 186 220 / 40%);
  font-size: 15px;
}
.Ecard .testMain {
  padding: 50px;
  min-height: 1000px;
}
.Ecard .banner {
  width: 100%;
}
.new_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
}

.hok_tab :deep(.el-tabs__item) {
  font-size: 16px;
  color: #fff;
}
.hok_tab :deep(.el-tabs__item.is-disabled) {
  color: #d3d3d3; /* 浅灰色 */
  cursor: not-allowed; /* 禁用光标样式 */
}
.hok_tab :deep(.el-tabs__item:hover) {
  color: #409eff;
}
.hok_tab :deep(.el-tabs__item.is-active) {
  color: #409eff;
}

.performance-table :deep(.el-checkbox__label) {
  color: #fff;
}
.all_table_hok_box {
  display: flex;
  align-items: center;
}

.all_table_hok .all_table_hok_left {
  font-size: 14px;
  padding: 12px;
  width: 100px;
  color: #fff;
  border-right: 1px solid #606469;
  border-bottom: 1px solid #606469;
  background: #42484e;
  flex-shrink: 0;
}

.all_table_hok .radil_list {
  flex-grow: 1;
  border-bottom: 1px solid #606469;
  height: 46px;
  align-items: center;
  display: flex;
}

.all_table_hok .radil_list .el-radio, 
.all_table_hok .radil_list_device .el-radio {
  color: #fff;
  margin-right: 0;
  margin-left: 10px;
  margin-top: 5px
}

.all_table_hok .radil_list .el-radio {
  width: 132px;
}

.my-table-hok:before {
  display: none;
}

.my-table-hok :deep(.el-table__row) {
  background-color: #42484e;
  font-size: 13px;
  color: #fff;
}

.my-table-hok :deep(tr:hover) {
  background-color: #42484e;
  color: #4ed8da;
}

.my-table-hok :deep(.is-leaf), 
.my-table-hok :deep(td) {
  border-bottom: 1px solid #606469;
}

.table-statics :deep(.el-table__body-wrapper) {
  background: rgb(45, 49, 54);
}

.el-form-item :deep(.el-form-item__label) {
  color: #fff;
}
</style>